import React from 'react';

import { WithAlloySuspense } from '@adsk/alloy-react-suspense';

import { HeadlessTabTitle, TabTitleProps } from './HeadlessTabTitle';
import {
  useUnsafeCurrentProductId,
  useUnsafeCurrentToolId,
} from '../helpers/ProvidersContexts';

export type { TabTitleProps };

const TabTitles = ({ productId, toolId, ...props }: TabTitleProps) => {
  const connectedProductId = useUnsafeCurrentProductId();
  const connectedToolId = useUnsafeCurrentToolId();

  return (
    <HeadlessTabTitle
      productId={productId || connectedProductId}
      toolId={toolId || connectedToolId}
      {...props}
    />
  );
};

export const TabTitle = WithAlloySuspense(TabTitles);
